const setVerticalMenuActiveItem = menuItemID => {
    return {
        type: 'SET_VERTICAL_MENU_ACTIVE_ITEM',
        data: menuItemID
    }
}

const setVerticalParentMenuActiveItem = menuItemID => {
    return {
        type: 'SET_VERTICAL_PARENT_MENU_ACTIVE_ITEM',
        data: menuItemID
    }
}

const setHeaderMenuActiveItem = menuItemID => {
    return {
        type: 'SET_HEADER_MENU_ACTIVE_ITEM',
        data: menuItemID
    }
}

const setLoading = loadingState => {
    return {
        type: 'SET_LOADING',
        data: loadingState
    }
}

const setMobileView = mobileView => {
    return {
        type: 'SET_MOBILE_VIEW',
        data: mobileView
    }
}

const setModal = modal => {
    return {
        type: 'SET_MODAL',
        data: modal
    }
}

const setModalState = modalState => {
    return {
        type: 'SET_MODAL_STATE',
        data: modalState
    }
}

const setAppModal = appModal => {
    return {
        type: 'SET_APP_MODAL',
        data: appModal
    }
}

const closeAppModal = () => {
    return {
        type: 'CLOSE_APP_MODAL'
    }
}

const setDrawerOpen = drawerOpenState => {
    return {
        type: 'SET_DRAWER_OPEN',
        data: drawerOpenState
    }
}

const setWarnUserBeforeExit = warnState => {
    return {
        type: 'SET_WARN_USER_BEFORE_EXIT',
        data: warnState
    }
}

const setMessages = messages => {
    return {
        type: "SET_MESSAGES",
        data: messages
    }
}

const setModalSpinner = spinnerDisplayState => {
    return {
        type: "SET_MODAL_SPINNER",
        data: spinnerDisplayState
    }
}

const setModalErrorMessageId = errorMessageId => {
    return {
        type: "SET_MODAL_ERROR_MESSAGE_ID",
        data: errorMessageId
    }
}

const setInquiryModal = (modalData) => {
    return {
        type: "SET_INQUIRY_MODAL",
        data: modalData
    }
}

const appActions = {
    setVerticalMenuActiveItem: setVerticalMenuActiveItem,
    setVerticalParentMenuActiveItem: setVerticalParentMenuActiveItem,
    setHeaderMenuActiveItem: setHeaderMenuActiveItem,
    setLoading: setLoading,
    setMobileView: setMobileView,
    setDrawerOpen: setDrawerOpen,
    setWarnUserBeforeExit: setWarnUserBeforeExit,
    setModalSpinner: setModalSpinner,
    setModal: setModal,
    setModalState: setModalState,
    setAppModal: setAppModal,
    closeAppModal: closeAppModal,
    setMessages: setMessages,
    setModalErrorMessageId: setModalErrorMessageId,
    setInquiryModal: setInquiryModal
}

export default appActions;